module.exports = __webpack_public_path__ + "img/Romantikken_norske-huldre-eventyr.c2ca9a74.jpg";